
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/episodes",
      function () {
        return require("private-next-pages/episodes/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/episodes"])
      });
    }
  